import { MDBListGroupItem } from "mdbreact";
import { NavLink } from "react-router-dom";

interface Props {
    icon: any,
    label: string,
    link: string,
    hasAccess: boolean
}

const accessDeniedUrl = '/noaccess';

const SideNavigationItem = (props: Props) => {
    if (props.hasAccess) {
        return (
            <NavLink to={props.link} activeClassName="activeClass">
                <MDBListGroupItem>
                    <img src={props.icon} className="mr-3" />
                    {props.label}
                </MDBListGroupItem>
            </NavLink>
        );
    }
    else {
        return <></>;
        /*
        return (
            <NavLink to={accessDeniedUrl} activeClassName="">
                <MDBListGroupItem className="disabledElementWithOpacity">
                    <img src={props.icon} className="mr-3" />
                    {props.label}
                </MDBListGroupItem>
            </NavLink>
        );
        */
    }
}

export default SideNavigationItem;